import { Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import {
  CustomInput,
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import PrescriptionSectionCard from './PrescriptionSectionCard'
import { HEADER_TYPES_ARRAY } from 'src/consumer/constants'
import { getEventTargetValueFromMuiToggleGroup } from 'src/consumer/helpers/utilFunctions'
import { getNumberStringForInput } from 'src/mentor/helpers/utilityFunctions'
import ImageUploadWithHeightAdjustment from '../ImageUploadWithHeightAdjustment'

/**
 * Section for header configuration
 * Handles header height, type, blank/filled state, title fields, and header image
 */
export default function HeaderDetailsSection({
  prescriptionTemplate,
  handleChangeHeader,
  disabled,
  isUsingNewPrintMethod = false,
}) {
  return (
    <PrescriptionSectionCard heading="Header Details">
      <Grid item xs={12}>
        <ImageUploadWithHeightAdjustment
          imageId={prescriptionTemplate?.header?.imageId}
          currentHeight={prescriptionTemplate?.header?.customHeaderHeight}
          prescriptionTemplate={prescriptionTemplate}
          type="header"
          defaultHeight={2}
          minHeight={0.5}
          maxHeight={5}
          onComplete={(imageId, adjustedHeight) => {
            // Update both imageId and height from modal
            handleChangeHeader({ target: { id: 'imageId', value: imageId } })
            handleChangeHeader({ target: { id: 'customHeaderHeight', value: adjustedHeight } })
          }}
          disabled={disabled}
          showSlider={isUsingNewPrintMethod}
          placeholder="Add Header Image"
        />
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          id="customHeaderHeight"
          label="Custom header height in inches (manual adjustment)"
          type="number"
          value={getNumberStringForInput(prescriptionTemplate?.header?.customHeaderHeight)}
          onChange={handleChangeHeader}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomSelect
          id="customHeaderType"
          value={prescriptionTemplate?.header?.customHeaderType}
          options={HEADER_TYPES_ARRAY}
          onChangeEvent={handleChangeHeader}
          label="Header Type"
          disabled={disabled}
          isClearable
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
          Header content
        </Typography>
        <ToggleButtonGroup
          color="primary"
          id="customHeaderBlank"
          size="small"
          value={prescriptionTemplate?.header?.customHeaderBlank ?? 'default'}
          exclusive
          onChange={(e, v) => {
            const actualValue = v === 'default' ? null : v
            handleChangeHeader(getEventTargetValueFromMuiToggleGroup(false, e, actualValue))
          }}
          sx={{
            flexWrap: 'wrap',
            '& .MuiToggleButtonGroup-grouped': { borderRadius: '8px !important' },
            '& .MuiToggleButton-root': { textTransform: 'none', px: 1.5, py: 0.75 },
          }}
        >
          <ToggleButton id="customHeaderBlank" value={true}>
            Show Blank Header
          </ToggleButton>
          <ToggleButton id="customHeaderBlank" value={false}>
            Show Filled Header
          </ToggleButton>
          <ToggleButton id="customHeaderBlank" value="default">
            Use Default Values
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          id="title"
          label="Main Heading"
          required
          value={prescriptionTemplate?.header?.title}
          onChange={handleChangeHeader}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomInput
          id="subTitle"
          label="Sub Heading"
          required
          value={prescriptionTemplate?.header?.subTitle}
          onChange={handleChangeHeader}
          disabled={disabled}
        />
      </Grid>
    </PrescriptionSectionCard>
  )
}
